export default __webpack_public_path__ + "static/media/lock.bfbd437c.png";